module.exports = __webpack_public_path__ + "static/media/demo_class_video_student_only_I.22d777e1.jpg";